import type { ReactNode } from 'react'
import { Loader2 } from 'lucide-react'

import { cn } from '@/lib/utils'

export const SKILL_SUGGESTION_OPTION_CLASS =
  'w-full truncate px-3 py-1.5 text-left hover:bg-accent focus:bg-accent focus:outline-none'

export function SkillSuggestionListbox({
  id,
  maxHeightClassName = 'max-h-48',
  isLoading,
  loadingLabel = 'Loading…',
  children,
}: {
  id: string
  maxHeightClassName?: string
  isLoading?: boolean
  loadingLabel?: string
  children: ReactNode
}) {
  return (
    <ul
      id={id}
      role="listbox"
      className={cn(
        'absolute left-0 right-0 top-full z-50 mt-1 overflow-y-auto rounded-md border border-border bg-popover py-1 text-sm shadow-md',
        maxHeightClassName
      )}
      onMouseDown={(event) => event.preventDefault()}
    >
      {isLoading ? (
        <li className="flex items-center gap-2 px-3 py-2 text-muted-foreground">
          <Loader2 className="size-4 shrink-0 animate-spin" aria-hidden />
          {loadingLabel}
        </li>
      ) : (
        children
      )}
    </ul>
  )
}

export function SkillSuggestionOption({
  name,
  onPick,
  className,
}: {
  name: string
  onPick: (name: string) => void
  className?: string
}) {
  return (
    <li>
      <button
        type="button"
        role="option"
        className={cn(SKILL_SUGGESTION_OPTION_CLASS, className)}
        onClick={() => onPick(name)}
      >
        {name}
      </button>
    </li>
  )
}
